import { overlay } from 'overlay-kit';
import InquiryModal from '../_components/modal/inquiry/InquiryModal';

export const useInquiryModal = () => {
  const inquiryModal = () => {
    overlay.open(({ isOpen, close }) => {
      return <InquiryModal isOpen={isOpen} close={close} />;
    });
  };

  return { inquiryModal };
};
